import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Logo from "@/components/Logo";
import { CONTACT, NAV, DEPARTMENTS } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-white">
      <div className="container-x py-16 grid gap-12 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <Logo variant="dark" withTagline />
          <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-xs">
            {CONTACT.activity}. « {CONTACT.slogan} »
          </p>
          <p className="mt-4 text-xs font-bold tracking-[0.2em] uppercase text-aqua">
            {CONTACT.signature}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-bold tracking-wide uppercase text-white/50 mb-4">Navigation</h4>
          <ul className="space-y-2.5">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-white/80 hover:text-aqua transition-colors">
                  {n.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/contact" className="text-sm text-white/80 hover:text-aqua transition-colors">Contact / Devis</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold tracking-wide uppercase text-white/50 mb-4">Zone d'intervention</h4>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
            {DEPARTMENTS.map((d) => (
              <li key={d.slug}>
                <Link to={`/zone-intervention/${d.slug}`} className="text-sm text-white/80 hover:text-aqua transition-colors">
                  {d.name} ({d.code})
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold tracking-wide uppercase text-white/50 mb-4">Contact</h4>
          <ul className="space-y-3.5 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <Phone size={16} className="text-aqua mt-0.5 shrink-0" />
              <a href={`tel:${CONTACT.phoneTel}`} className="hover:text-aqua transition-colors">{CONTACT.phoneDisplay}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="text-aqua mt-0.5 shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-aqua transition-colors">{CONTACT.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="text-aqua mt-0.5 shrink-0" />
              {CONTACT.zone}
            </li>
            <li className="flex items-start gap-3">
              <Clock size={16} className="text-aqua mt-0.5 shrink-0" />
              {CONTACT.hours}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} FuiteX — Tous droits réservés.</p>
          <div className="flex gap-5">
            <Link to="/mentions-legales" className="hover:text-white/80 transition-colors">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-white/80 transition-colors">Confidentialité</Link>
            <Link to="/cgv" className="hover:text-white/80 transition-colors">CGV</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
